import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=2faa7dd6&"
import script from "./menu.js?vue&type=script&lang=js&"
export * from "./menu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports